module.exports = __webpack_public_path__ + "img/avatar.20c2b82f.jpg";